import { Directive, ElementRef, HostListener } from '@angular/core';
import { CepFormatPipe} from "../_pipes/cep-format.pipe";
import {PhoneFormatPipe} from "../_pipes/phone-format.pipe";

@Directive({
  selector: '[appCepMask]',
  standalone: true
})
export class CepMaskDirective {

  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event'])
  onInputChange(event: any) {
    let inputValue: string = this.el.nativeElement.value;
    let unformattedValue = CepFormatPipe.format(inputValue);
    this.el.nativeElement.value = new CepFormatPipe().transform(unformattedValue);
  }
}
